import { _ } from "libs";
import React, { memo, forwardRef, MutableRefObject } from "react";
import moment from "moment";
import { messageRelativePastTime } from "../../../actions/messageRelativePastTime";
import Avatar from "../../avatar";
import ReadInfo from "../readInfo";
import { openPlayerPopup } from "../../../actions";
import { MessageProps } from "../types";
import CourtItemMedium from "../../items/court/medium";
import { Link } from "react-router-dom";
import { Court, Club } from "../../../types";

const SlotMessage = memo(
	forwardRef(
		(
			{ message, partners, partner, lastReadByPartners, userId }: MessageProps,
			ref: MutableRefObject<HTMLDivElement>
		) => {
			const relativePastTimeString = messageRelativePastTime(message.createdAt);
			const slot = message.text.payload.slotPayload;
			const club = slot.club as Club;
			const court = slot.court as Court;
			const sportString = _("courtSport." + court.sport);
			const date =
				moment.unix(slot.startDateTime).format("dddd, MMM") +
				"\u00A0" +
				moment.unix(slot.startDateTime).format("D");

			return (
				<div
					className={`item message${message.text.deleted! ? " deleted" : ""}`}
					ref={ref}
					data-id={message.messageId}
				>
					<div className="itemImage" onClick={openPlayerPopup.bind(null, partner.userId)}>
						<Avatar photoUrl={partner.photoUrl} />
					</div>
					<div className="itemBody">
						<div className="messageBody" title={relativePastTimeString}>
							<div className="text">
								{_("chat.slotMessage", null, {
									sport: sportString,
									club: club.clubInfo.name,
									date: date,
									time: moment.unix(slot.startDateTime).format("H:mm"),
									duration: (slot.endDateTime - slot.startDateTime) / 60,
									price: undefined, //court.priceString,
								})}
							</div>
							<Link
								className="object clickable"
								to={`/club/${club.clubInfo.clubId}?timestamp=${slot.startDateTime}&court=${court.courtId}`}
							>
								<CourtItemMedium court={court} />
							</Link>
						</div>
						{lastReadByPartners ? (
							<ReadInfo
								partners={partners}
								lastReadByPartners={lastReadByPartners}
								userId={userId}
								senderId={message.senderId}
							/>
						) : null}
					</div>
				</div>
			);
		}
	)
);

SlotMessage.displayName = "SlotMessage";
export default SlotMessage;
